import PropTypes from 'prop-types';
import { Badge } from '@mui/material';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

const StatusBadge = styled(Badge)(({ theme, status }) => ({
  '& .MuiBadge-badge': {
    backgroundColor:
      (status === 'online' && theme.palette.success.main) ||
      (status === 'busy' && theme.palette.warning.main) ||
      theme.palette.error.main,
    color:
      (status === 'online' && theme.palette.success.main) ||
      (status === 'busy' && theme.palette.warning.main) ||
      theme.palette.error.main,
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

// ----------------------------------------------------------------------

UserStatusIndicator.propTypes = {
  status: PropTypes.string,
  children: PropTypes.node,
};

export default function UserStatusIndicator({ status, children, ...other }) {
  return (
    <StatusBadge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      variant="dot"
      status={status}
      {...other}
    >
      {children}
    </StatusBadge>
  );
}
